const ClamavIcon = ({ color = "var(--border)", width = 24, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width={width}
      height={height}>
      <path
        fill={color}
        d="M 13 13 A 1 1 0 0 0 22 8 L 22 8 L 13 13 M 12 19 Z M 2 8 A 1 1 0 0 0 11 13 L 11 13 Z M 24 0 L 22.745 6.691 C 23.541 8.294 24 10.092 24 12 C 24 18.617 18.617 24 12 24 C 5.383 24 0 18.617 0 12 C 0 10.093 0.46 8.294 1.255 6.691 L 0 0 L 4 3 C 6.973 0.849 9.386 0 12 0 S 17.027 0.849 20 3 L 24 0 Z"
      />
    </svg>
  );
};

export default ClamavIcon;
